import { render, staticRenderFns } from "./ResourcesMngtReg.vue?vue&type=template&id=65d188e6"
import script from "./ResourcesMngtReg.vue?vue&type=script&lang=js"
export * from "./ResourcesMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports